export default "__VITE_ASSET__1b0dc5dc__"